import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/play.png'
import _imports_1 from '@/assets/icons/pause.png'
import _imports_2 from '@/assets/icons/navigation.png'


const _withScopeId = n => (_pushScopeId("data-v-4991257f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "playDiv"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "actionStyle playSpan" }, "Parours live", -1))
const _hoisted_3 = {
  key: 0,
  class: "icon play",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "icon play",
  src: _imports_1
}
const _hoisted_5 = ["value", "max"]
const _hoisted_6 = {
  key: 1,
  class: "travel"
}
const _hoisted_7 = { class: "travelSpan" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "travelImg",
  src: _imports_2
}, null, -1))
const _hoisted_9 = { class: "courseInfo" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx, _cache) {
  const _component_apexchart = _resolveComponent("apexchart")
  const _component_SideNav = _resolveComponent("SideNav")

  return (!_ctx.isMobileView)
    ? (_openBlock(), _createBlock(_component_SideNav, {
        key: 0,
        class: _normalizeClass(["elevProfile", {'hidden': !_ctx.visible}]),
        expanded: _ctx.expanded,
        width: _ctx.sideNavWidth,
        height: 220,
        position: "right",
        icon: "elev-profile.png"
      }, {
        sideNavTitle: _withCtx(() => [
          _createTextVNode(" Profil d'élévation ")
        ]),
        sideNavContent: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.showPlay)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: "playBtn actionBtn angled",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)))
                  }, [
                    _hoisted_2,
                    (!_ctx.isPlaying)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                      : _createCommentVNode("", true),
                    (_ctx.isPlaying)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("progress", {
                    class: "playProgressBar",
                    value: _ctx.progressValue,
                    max: _ctx.progressMaxValue
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showPlay)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.progressValue && _ctx.progressValue < 100)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "travelDiv",
                        style: _normalizeStyle({left: `calc(${_ctx.progressValue}%)`})
                      }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.traveledDistance) + " KM", 1),
                        _hoisted_8
                      ], 4))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString((_ctx.distance / 1000).toFixed(3)) + " km ", 1),
                _hoisted_11,
                _createTextVNode(" ↑ " + _toDisplayString(_ctx.positiveElevation) + " m ↓ " + _toDisplayString(_ctx.negativeElevation) + " m", 1)
              ])
            ]),
            (!_ctx.isUpdating)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 2,
                  class: _normalizeClass(["elevProfileChart", {'showPlay': _ctx.showPlay}]),
                  width: _ctx.sideNavWidth - 140,
                  height: _ctx.showPlay ? 200 : 220,
                  type: "area",
                  options: _ctx.options,
                  series: _ctx.options.series
                }, null, 8, ["class", "width", "height", "options", "series"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["class", "expanded", "width"]))
    : _createCommentVNode("", true)
}